import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from './login.component';
import {Principal} from '../../block/auth/principal.service';
import {StateStorageService} from '../../block/auth/state-storage.service';
import {AuthServerProvider} from '../../block/auth/auth-jwt.service';
import {LoginRoutingModule} from './login-routing.module';
import {PasswordResetInitComponent} from './password-reset/init/password-reset-init.component';
import {PasswordResetFinishComponent} from './password-reset/finish/password-reset-finish.component';
import {SharedModule} from '../../shared/shared.module';
import {BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {WelcomeService} from '../welcome/welcome.service';

@NgModule({
  declarations: [
    LoginComponent,
    PasswordResetInitComponent,
    PasswordResetFinishComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    LoginRoutingModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [
    Principal,
    AuthServerProvider,
    StateStorageService,
    BsModalService,
    WelcomeService
  ],
  exports: [
  ]
})
export class LoginModule { }
